<div class="copyright">&copy; FBS Markets Inc., 2009-{{ now | date : 'yyyy' }}</div>
<div class="language-select" (click)="onLanguageChangeClick()">
  <div class="language-select__image-wrapper">
    <img
      alt=""
      class="language-select__flag"
      src="./assets/img/flags/{{ (currentLanguage.substring(0, 2) | langToCountryCode) }}.svg"
    />
  </div>
  {{ ("languages." + currentLanguage) | translate }}
</div>
